import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

axios.interceptors.request.use(
  (config) => {
    const getTokenFromLocalStorage = localStorage.getItem("user_website")
      ? JSON.parse(localStorage.getItem("user_website"))
      : null;
    const token = getTokenFromLocalStorage?.token || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Fixed the missing semicolon
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


const getProducts = async (data) => {
  console.log(data);
  const response = await axios.get(`${base_url}product/getProducts`);

  if (response.data) {
    return response.data;
  }
};

const getNewArrivals = async (data) => {
  console.log(data);
  const response = await axios.get(`${base_url}product/new-arrivals`);

  if (response.data) {
    return response.data;
  }
};

const getLatestProducts = async (data) => {
  console.log(data);
  const response = await axios.get(`${base_url}product/latest`);

  if (response.data) {
    return response.data;
  }
};

const getProCategories = async (data) => {
  console.log(data);
  const response = await axios.get(`${base_url}categories/top`);

  if (response.data) {
    return response.data;
  }
};

const getSingleProduct = async (id) => {
  const response = await axios.get(`${base_url}product/getProductsById/${id}`);
  if (response.data) {
    return response.data;
  }
};

const getCategory = async (id) => {
  const response = await axios.get(`${base_url}category/getAllCategory`);
  if (response.data) {
    return response.data;
  }
};

const addToWishlist = async (wishData) => {
  const response = await axios.put(
    `${base_url}wishlist/add`,
    { wishData },
    config
  );
  if (response.data) {
    return response.data;
  }
};

const rateProduct = async (data) => {
  const response = await axios.put(`${base_url}product/rating`, data, config);
  if (response.data) {
    return response.data;
  }
};

const order = async (data) => {
  const response = await axios.post(
    `${base_url}product/orderProducts`,
    data,
    config
  );
  if (response.data) {
    return response.data;
  }
};

export const productSevice = {
  getProducts,
  getNewArrivals,
  getLatestProducts,
  getProCategories,
  addToWishlist,
  getSingleProduct,
  rateProduct,
  getCategory,
  order,
};
